import React, { useCallback, useEffect } from 'react';

import DestinationAutocomplete from 'component/Search/Destination';
import { CustomSearchInputClassList } from 'component/Search/Input/types';

import { emptyDestination } from 'config/SearchForm/defaults';

import { useDestination, useSetCurrentSearch } from 'hooks/form/search';

import {
    DestinationValue,
    SearchStep,
    ValidationType,
} from 'types/Search/form';

interface DestinationAutocompleterProps {
    onSubmit?: () => void;
    initialValue?: DestinationValue;
    placeholder: string;
    label: string;
    customClassList?: CustomSearchInputClassList;
    onValidate?: (type: ValidationType, isEmpty: boolean) => void;
}

const Destination = ({
    onSubmit,
    initialValue,
    placeholder,
    label,
    customClassList,
    onValidate,
}: DestinationAutocompleterProps) => {
    const [destinationValue, setDestinationValue] = useDestination();
    const setCurrentSearch = useSetCurrentSearch();

    const onValueChange = useCallback(
        (value: DestinationValue) => {
            setDestinationValue(value);
            onSubmit?.();
            onValidate?.(ValidationType.Destination, !value.label);
        },
        [onSubmit, setDestinationValue, onValidate]
    );

    const onEmptyDestinationClick = useCallback(() => {
        setCurrentSearch((current) => ({
            ...current,
            destination: {
                ...emptyDestination,
                searchStep: SearchStep.Region,
            },
        }));
        onSubmit?.();
    }, [onSubmit, setCurrentSearch]);

    useEffect(() => {
        if (initialValue) {
            setDestinationValue(initialValue);
        }
    }, [initialValue, setDestinationValue]);

    return (
        <DestinationAutocomplete
            destinationValue={destinationValue}
            onValueChange={onValueChange}
            onEmptyDestinationClick={onEmptyDestinationClick}
            placeholder={placeholder}
            label={label}
            customClassList={customClassList}
        />
    );
};

export default Destination;
